/**Табы для редактирования очереди */
enum EditQueueEnum {
  /**Основная информация */
  Main = "main",
  /**Сотрудники */
  Employees = "employees",
  /**Статусы */
  Statuses = "statuses",
  /**Приоритеты */
  Priorities = "priorities",
}
export { EditQueueEnum };
